/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import './index.css';
import GlobalStyles from './styles/GlobalStyles';
import App from './App';
import { Provider } from 'react-redux';
import AWSHubStore from './redux/AWSHubStore';
import reportWebVitals from './reportWebVitals';
import Amplify from 'aws-amplify';
// import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import awsconfig from './aws-exports';
import { AppsyncCdkRdsStack } from './cdk-exports.json';
// import cdkconfig from './cdk-exports.js';
import "./static/iconfont/iconfont.css"

let version = "dev";
try{
  version = require("./version.json").version;
  
}catch(error) {};

window.awshub_version = version;

const config = _.merge(awsconfig,
  {
    Auth: {
      region: awsconfig.aws_project_region,
      userPoolId: awsconfig.aws_user_pools_id,
      userPoolWebClientId: awsconfig.aws_user_pools_web_client_id
    },
    // aws_appsync_region: AppsyncCdkRdsStack.ProjectRegion,
    // aws_appsync_graphqlEndpoint: AppsyncCdkRdsStack.AppSyncAPIURL,
    // aws_appsync_apiKey: AppsyncCdkRdsStack.AppSyncAPIKey,
    //aws_appsync_authenticationType: "API_KEY", //Primary AWS AppSync authentication type
    // aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
  });
Amplify.configure(config);
ReactDOM.render(
  <React.StrictMode>
    {/* <GlobalStyles /> */}
    <Provider store={AWSHubStore}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
